import { Directive, booleanAttribute, input } from '@angular/core';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost';

const VARIANTS: readonly ButtonVariant[] = ['primary', 'secondary', 'ghost'];

/**
 * Bouton de la maquette, appliqué à un `<button>` ou un `<a>` natif.
 *
 * Une directive et non un composant : sur un `<button>` natif on hérite de
 * `disabled`, du type de soumission, de la gestion clavier et du rôle
 * d'accessibilité sans rien réécrire.
 *
 * Trois variantes seulement, et volontairement : « primary » en terre cuite est
 * l'action d'engagement — payer, publier —, « secondary » l'alternative
 * équivalente, « ghost » l'action de consultation. Ajouter une quatrième
 * variante diluerait la hiérarchie que la maquette installe.
 */
@Directive({
  selector: 'button[ctButton], a[ctButton]',
  host: {
    class: 'ct-btn',
    '[class.ct-btn--primary]': "variant() === 'primary'",
    '[class.ct-btn--secondary]': "variant() === 'secondary'",
    '[class.ct-btn--ghost]': "variant() === 'ghost'",
    '[class.ct-btn--block]': 'block()',
  },
})
export class CtButton {
  /** `ctButton` sans valeur donne un bouton secondaire. */
  readonly variant = input<ButtonVariant, string>('secondary', {
    alias: 'ctButton',
    transform: (value) =>
      (VARIANTS as readonly string[]).includes(value) ? (value as ButtonVariant) : 'secondary',
  });

  /** Pleine largeur, comme les boutons d'action de la maquette mobile. */
  readonly block = input(false, { transform: booleanAttribute });
}
